import { StatusCodes } from 'http-status-codes';
import request from '../infra/request';
import { STATUS } from '../constants';
import { buildPatientAuthorizationHeader } from '../utils/patientAccessStorage';

const { OK, CREATED } = StatusCodes;

export const getWorkflowById = async (workflowId) => {
  try {
    const { data, error, status } = await request.get('/api/workflow', {
      params: {
        workflowId,
      },
    });

    if (status === OK && data) {
      return { data };
    }

    return { error };
  } catch (error) {
    return { error };
  }
};

export const verifyDateOfBirth = async (workflowId, dateOfBirth) => {
  try {
    const { data } = await request.post(
      `/api/workflow/${workflowId}/verify-dob`,
      { dateOfBirth }
    );

    return { data };
  } catch (error) {
    return {
      error,
      httpStatus: error?.response?.status,
      data: error?.response?.data,
    };
  }
};

export const getVerifiedWorkflowById = async (workflowId) => {
  try {
    const { data, status } = await request.get(
      `/api/workflow/${workflowId}/details`,
      { headers: buildPatientAuthorizationHeader(workflowId) }
    );

    if (status === OK && data) {
      return { data };
    }

    return { error: 'Can not fetch workflow details', httpStatus: status };
  } catch (error) {
    return { error, httpStatus: error?.response?.status };
  }
};

export const recordActivity = async (workflowId, activity) => {
  try {
    const { error, status } = await request.post(
      `/api/workflow/${workflowId}/activity`,
      activity
    );

    if (status === CREATED) {
      return { status: STATUS.SUCCESS };
    }

    return { error, status: STATUS.FAILURE };
  } catch (error) {
    return { error, status: STATUS.FAILURE };
  }
};
